export default __webpack_public_path__ + "static/media/Wildfires b3d9e422614f40ec8f10a1a1bc82466b.296c63aa.md";